import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { recommendTagActions } from '../../../store/modules/recommend/tag';
import {
  RECOMMEND_TAG_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_TAG_LIST_SEARCH_OPTION_MODEL,
} from '../../../store/modules/recommend/tag/models';
import RecommendTagListWrap from '../../../views/recommend/tag/list/RecommendTagListWrap';

class RecommendTagListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_TAG_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['recommendTagList', 'searchData'],
      value: RECOMMEND_TAG_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getTagReviewList, recommendTagList } = this.props;
    const { searchOption, sortOption, pagination } = recommendTagList;

    getTagReviewList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { recommendTagList, setData } = this.props;

    return <RecommendTagListWrap recommendTagList={recommendTagList} setData={setData} getList={this.getList} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendTagList: state.recommendTag.recommendTagList,
  };
};

const mapDispatchToProps = {
  setData: recommendTagActions.setData,
  getTagReviewList: recommendTagActions.getTagReviewList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendTagListContainer);
